import { Component, Prop, Vue } from 'vue-property-decorator';
import { OrderStatusEnum, OrderStatusKeyInfo } from '@/items/OrderStatus';
import { SelectInputItemInterface } from '@/interfaces/SelectInputItemInterface';

@Component<OrderStatusAutocomplete>({})
export default class OrderStatusAutocomplete extends Vue {

  // #region @VModel
  // #endregion

  // #region @PropSyncs
  // #endregion

  // #region @Props

  @Prop({ default: 'Order status' })
  protected label!: string;

  @Prop({
    default: (): SelectInputItemInterface[] => (Object.values(OrderStatusEnum) as OrderStatusEnum[])
      .map((key) => ({
        id: key,
        name: OrderStatusKeyInfo[key]
          && OrderStatusKeyInfo[key].label
            ? OrderStatusKeyInfo[key].label
            : key,
      }))
  })
  protected items!: SelectInputItemInterface[];

  @Prop({
    default: () => OrderStatusKeyInfo[OrderStatusEnum.DRAFT]
      && OrderStatusKeyInfo[OrderStatusEnum.DRAFT].label
        ? OrderStatusKeyInfo[OrderStatusEnum.DRAFT].label
        : OrderStatusEnum.DRAFT
  })
  protected placeholder!: string;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}
